import { debounce } from 'lodash'
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { device } from 'src/atoms/responsive'

const RESIZE_TIMEOUT = 200

export const tablet = 768
export const laptop = 992
export const desktop = 1280
export const desktopLarge = 1440

export enum DevicesSizes {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  LAPTOP = 'laptop',
  DESKTOP = 'desktop',
  DESKTOP_LARGE = 'desktop-large',
}

export type MobileElementProps = {
  $mobile?: boolean
}

export const getDevice = (): DevicesSizes => {
  return window.innerWidth < tablet
    ? DevicesSizes.MOBILE
    : window.innerWidth < laptop
      ? DevicesSizes.TABLET
      : window.innerWidth < desktop
        ? DevicesSizes.LAPTOP
        : window.innerWidth < desktopLarge
          ? DevicesSizes.DESKTOP
          : DevicesSizes.DESKTOP_LARGE
}

export const useDevice = () => {
  const [currentDevice, setCurrentDevice] = useRecoilState(device)

  const onResizeDevice = debounce(() => {
    setCurrentDevice(getDevice())
  }, RESIZE_TIMEOUT)
  useEffect(() => {
    setCurrentDevice(getDevice())
    window.addEventListener('resize', onResizeDevice)
    return () => {
      window.removeEventListener('resize', onResizeDevice)
    }
  }, [])

  return {
    device: currentDevice,
    isMobile: currentDevice === DevicesSizes.MOBILE,
    isTablet: currentDevice === DevicesSizes.TABLET,
    isLaptop: currentDevice === DevicesSizes.LAPTOP,
    isDesktop: currentDevice === DevicesSizes.DESKTOP,
    isDesktopLarge: currentDevice === DevicesSizes.DESKTOP_LARGE,
  }
}
